PJQ.views.files.FilePropertiesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-File-Properties')
	},
	defaultEvents: {
		'click .btn-download': 'download',
		'click .btn-export-file-list': 'exportFileList'
	},
	beforeModalCreated: function () {
		// if(this.model.get('isFolder')){
		// 	this.model.fetch();
		// }
	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	download: function () {
		if (this.options.project != null) {
			this.options.project.checkDownloadRequirements(_.bind(function () {
				this.options.project.downloadAttachments(this.model);
			}, this));
		}
		else {
			if(this.model.get('isFolder')){
				new PJQ.collections.files.Files(this.model.getFolderAttachments(true)).download();
			}
			else{
				this.model.download();
			}
		}
	},
	exportFileList: function () {
		this.model.exportFileList();
	}
});